import * as v from 'valibot';

import { newSchema } from '../../utils/valibot/schema';

export enum TimeAggregation {
  MONTHLY = 'MONTHLY',
  DAILY = 'DAILY',
}

export interface FilterCriteria {
  timeAggregation: TimeAggregation;
  from: Date;
  to: Date;
  country: string | undefined;
  usecases: string[];
}

export interface ReportingFile {
  file: Blob;
  filename: string;
}

export const ReportingOptionsSchema = newSchema(
  'ReportingOptionsSchema',
  v.object({
    countries: v.array(v.string()),
    usecases: v.array(v.string()),
  }),
);

export type ReportingOptions = v.InferOutput<typeof ReportingOptionsSchema>;
